const MAX_PHOTO_SIZE = 29; // Kb. Pubnub max is 32 (leave 3kb to other staff)
function compressImage(canvas, maxSize) {
  var compression = 1.0;
  while (compression > 0.01) {
    var dataURL = canvas.toDataURL('image/jpeg', compression);
    if (dataURL.length / 1024 < maxSize) return dataURL;
    if (compression <= 0.1) {
      compression -= 0.01;
    } else {
      compression -= 0.05;
    }
  }
  return null;
}

export default angular
  .module('doxy.realtime.common.services.photoFactory', [])
  .factory('photoFactory', function ($window, $document) {
    function resizeCrop(photo, options = {}) {
      return new Promise((resolve) => {
        const img = new $window.Image();
        let width = options.width;
        let height = options.height;

        img.onload = function (e) {
          var crop = width == 0 || height == 0;
          const src = e.target;
          // not resize
          if (src.width <= width && height == 0) {
            width = src.width;
            height = src.height;
          }
          // resize
          if (src.width > width && height == 0) {
            height = src.height * (width / src.width);
          }

          // check scale
          var xscale = width / src.width;
          var yscale = height / src.height;
          var scale = crop
            ? Math.min(xscale, yscale)
            : Math.max(xscale, yscale);
          // create empty canvas
          var canvas = document.createElement('canvas');
          canvas.width = width ? width : Math.round(src.width * scale);
          canvas.height = height ? height : Math.round(src.height * scale);
          canvas.getContext('2d').scale(scale, scale);
          // crop it top center
          canvas
            .getContext('2d')
            .drawImage(
              src,
              (src.width * scale - canvas.width) * -0.5,
              (src.height * scale - canvas.height) * -0.5
            );
          // 30 - max image length
          resolve(compressImage(canvas, options.maxFileSize || MAX_PHOTO_SIZE));
        };

        img.src = photo;
      });
    }

    function resize(photo, size) {
      return new Promise((resolve) => {
        const img = new $window.Image();
        img.width = size.width;
        img.height = size.height;

        img.onload = function () {
          const canvas = $window.document.createElement('canvas');
          canvas.width = size.width;
          canvas.height = size.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, size.width, size.height);
          resolve(canvas.toDataURL());
        };

        img.src = photo;
      });
    }

    function getTextImage(text, options = {}) {
      options = Object.assign(
        {
          align: 'center',
          width: 360,
          height: 36,
          background: 'white',
          fontColor: 'black',
          maxFileSize: MAX_PHOTO_SIZE,
        },
        options
      );

      const canvas = $document[0].createElement('canvas');
      canvas.width = options.width;
      canvas.height = options.height;

      let xCoordinate;
      let textAlign;

      switch (options.align) {
        case 'left':
          xCoordinate = 0;
          textAlign = 'start';
          break;
        case 'right':
          xCoordinate = canvas.width;
          textAlign = 'end';
          break;
        case 'center':
        default:
          xCoordinate = canvas.width / 2;
          textAlign = 'center';
      }

      const ctx = canvas.getContext('2d');

      // Create background
      ctx.beginPath();
      ctx.rect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = options.background;
      ctx.fill();

      // Fill with text
      ctx.font = '28px Mrs Saint Delafield';
      ctx.textAlign = textAlign;
      ctx.textBaseline = 'middle';
      ctx.fillStyle = options.fontColor;

      // Add extra spaces to the text to avoid font serifs being cut
      ctx.fillText(` ${text} `, xCoordinate, canvas.height / 2);

      const dataUrl = compressImage(canvas, options.maxFileSize);
      canvas.remove();
      return dataUrl;
    }

    function takeVideoSnapshot(
      videoEl,
      width = videoEl.offsetWidth,
      height = videoEl.offsetHeight
    ) {
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(videoEl, 0, 0, width, height);

      const imgData = canvas.toDataURL('image/png');
      return imgData;
    }

    return { resize, resizeCrop, getTextImage, takeVideoSnapshot };
  }).name;
